import type {
  UserQuestDetail,
  UserQuestProgress,
} from "Infrastructure/Api/Api";
import { UserQuestProgress as UserQuestProgressEnum } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useMemo } from "react";
import { useRequestStatusConfig } from "./useRequestStatusConfig";

export const useUserQuestStatusFilterOptions = (
  requests: UserQuestDetail[],
) => {
  const { t } = useResource();
  const requestStatusConfig = useRequestStatusConfig();

  return useMemo(() => {
    const counts = requests.reduce(
      (acc, r) => {
        acc[r.progress] = (acc[r.progress] || 0) + 1;
        return acc;
      },
      {} as Record<UserQuestProgress, number>,
    );

    return [
      {
        value: "all",
        label: t(Resources.RequestCards.Filters.All),
        count: requests.length,
      },
      ...Object.values(UserQuestProgressEnum).map((status) => ({
        value: status,
        label: t(requestStatusConfig[status].labelKey),
        count: counts[status] || 0,
      })),
    ];
  }, [requests, t, requestStatusConfig]);
};
